import { render } from "./EmployeeLeaveRequest.vue?vue&type=template&id=fb05d5ec&scoped=true&ts=true"
import script from "./EmployeeLeaveRequest.vue?vue&type=script&lang=ts"
export * from "./EmployeeLeaveRequest.vue?vue&type=script&lang=ts"

import "./EmployeeLeaveRequest.vue?vue&type=style&index=0&id=fb05d5ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb05d5ec"]])

export default __exports__